import React from 'react';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;

const NonExclusiveModal = ({ onAccept }) => {
    return (
        <React.Fragment>
            <br />
            <h3 className="font-heading3">{formatText('identity-videoCallModalTitle')}</h3>
            <div className="video-screen__modal-body-content">
                <i className="icons icons--icon-warning-gray"></i>
                <p className="video-screen__modal-body-text font-paragraph2">
                    <FormattedText value="identity-videoCallModalText1" />
                </p>
            </div>
            <div className="video-screen__modal-buttons">
                <button className="form__button form__button-secondary" onClick={onAccept}>
                    {formatText('button-understood')}
                </button>
            </div>
        </React.Fragment>
    );
};

export default NonExclusiveModal;
